import React, { Component } from 'react';
import './FailurePrediction.css';
import { connect } from 'react-redux';
import { t } from 'i18next';
import TitleBar from '../../../titleBar/TitleBar';
import Modal from '../../../modal/Modal';

import { pullResultsService } from '../../services/testResultsService';

import FailurePredictionGraphComponent from
  '../../subComponents/TensorGraphs/FailurePredictionGraph/FailurePredictionGraphComponent';
import FailurePredictionTableComponent from './FailurePredictionTableComponent';

class FailurePrediction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jobNamesList: [],
      modalOpen: false,
      selectedJobName: {
        name: 'jobName',
        predictedDate: '0',
      },
      tempSelectedJobName: 'jobName',
      threshold: 70,
    };

    this.thresholdChangeHandler = this.thresholdChangeHandler.bind(this);
    this.handleTempJobNameChange = this.handleTempJobNameChange.bind(this);
    this.acceptCloseModal = this.acceptCloseModal.bind(this);

    // Open and close modal functionality
    this.openModal = () => this.setState({
      modalOpen: true,
    });
    this.closeModal = () => this.setState({
      modalOpen: false,
    });
  }

  componentDidMount() {
    pullResultsService(false).then((requestData) => {
      this.setState({
        jobNamesList: requestData.jobs,
        selectedJobName: {
          name: requestData.jobs[0],
          predictedDate: '4' || 'TODO',
        },
        tempSelectedJobName: requestData.jobs[0],
      });
    }).catch((error) => {
      console.error('Error', error);
    });
  }

  // Threshold handler from Graph
  thresholdChangeHandler(newThreshold) {
    this.setState({
      threshold: newThreshold,
    });
  }

  // JobName handler from Modal
  handleTempJobNameChange(event) {
    this.setState({
      tempSelectedJobName: event.target.value,
    });
  }

  // jobName Modal select jobName function
  acceptCloseModal() {
    const { selectedJobName, tempSelectedJobName } = this.state;
    selectedJobName.name = tempSelectedJobName;
    this.setState({
      selectedJobName,
    }, this.closeModal());
  }

  render() {
    const {
      modalOpen,
      tempSelectedJobName,
      modalIsOpen,
      jobNamesList,
      selectedJobName,
      threshold,
    } = this.state;
    return (
      <div className="failure-prediction-page">
        <TitleBar title={t('tensorAnalytics.failurePredictionPage.title')} />
        <div className="pageContent">
          {modalOpen && (
            <Modal title={t('tensorAnalytics.failurePredictionPage.jobNameModalTitle')}
              close={this.closeModal}
              isOpen={modalIsOpen}
              className="modal"
            >
              <div className="content">
                <select value={tempSelectedJobName}
                  onChange={this.handleTempJobNameChange}
                >
                  {jobNamesList.map(jobName => (
                    <option value={jobName}>
                      {jobName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="actions">
                <button type="button" onClick={this.closeModal}>{t('tensorAnalytics.common.cancel')}</button>
                <button type="button"
                  className="submit"
                  onClick={this.acceptCloseModal}
                >
                  {t('tensorAnalytics.common.accept')}
                </button>
              </div>
            </Modal>
          )}
          <div className="jobNameSelector"
            onClick={() => this.openModal()}
            onKeyDown={() => this.openModal()}
            role="button"
            tabIndex={0}
          >
            <span>
              {t('tensorAnalytics.failurePredictionPage.jobNameModalTitle')}
              {/* linting can't handle semicolons in spans : */}
              {selectedJobName.name}
            </span>
            <img role="presentation"
              alt={t('tensorAnalytics.common.refresh')}
              src="closeLight.svg"
              className="resetIco"
            />
          </div>
          <div className="failure-prediction">
            <div className="graph-container">
              <h6>
                {t('tensorAnalytics.failurePredictionPage.likelihoodHeader', {
                  predictedDate: selectedJobName.predictedDate,
                })}
              </h6>
              <FailurePredictionGraphComponent changeThreshold={this.thresholdChangeHandler}
                threshold={threshold}
              />
            </div>

            <div className="table-container">
              <h6>
                {t('tensorAnalytics.failurePredictionPage.forecastHeader', {
                  predictedDate: selectedJobName.predictedDate,
                })}
              </h6>
              <FailurePredictionTableComponent jobName={selectedJobName.name}
                threshold={threshold}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(FailurePrediction);
